// Menu type
export const MENU_TYPE_GOVERNANCE = 'governance'
export const MENU_TYPE_COMPLIANCE = 'compliance'
// export const MENU_TYPE_GOV_ORG_CHART = 'organization-chart'
export const MENU_TYPE_GOV_ORG_CHART = 'manage-org-chart'
export const MENU_TYPE_VIEW_ORG_CHART = 'manage-org-chart'
// export const MENU_TYPE_GOV_SETUP = 'compliance-setup'
export const MENU_TYPE_GOV_MANAGEMENT_STRUCTURE = 'management-structure'
// export const MENU_TYPE_RISK_LIST = 'raised'
export const MENU_TYPE_RISK_LIST = 'risk-register'
export const MENU_TYPE_RISK = 'risk-register'
export const MENU_TYPE_REJECTED_RISK = 'rejected-risk'
export const MENU_TYPE_RISK_DISPUTE = 'dispute'
export const MENU_TYPE_RISK_HISTORY = 'history'
// ISSUE
export const MENU_TYPE_ISSUE = 'issue-register'
export const MENU_TYPE_ISSUE_HISTORY = 'issue-history'
// export const MENU_TYPE_COMPLAINCE = 'compliance'
export const MENU_TYPE_COMPLIANCE_SETUP = 'compliance-setup'
export const MENU_TYPE_GOVERNANCE_SETUP = 'governance-setup'
export const MENU_TYPE_MANAGE_COMPLAINCE = 'manage-compliance'
export const MENU_TYPE_TRANSFER_BODY = 'reassign-body'
export const MENU_TYPE_TRANSFER_COMPLIANCE = 'reassign-compliance'
export const MENU_TYPE_NOTIFICATION = 'notification'
export const MENU_TYPE_SETTINGS = 'settings'
export const MENU_TYPE_HELP_CENTER = 'help-center'
export const MENU_TYPE_DASHBOARD = 'dashboard'
export const MENU_TYPE_MEETINGS = 'meeting'
export const STRING = 'string'
export const getSurveyTemplateDataNew = [
    {
        groupId: 1,
        groupName: 'Profile',
        questions: [
            {
                qId: 2,
                qName: 'Organization Name',
                inputTypeId: 1,
                inputTypeName: 'TextField',
                questionGroupId: 2,
                questionGroupName: 'Organization Profile',
                isMandatory: true,
                options: [],
                // answerNumeric: null,
                answerText: '',
                // answerKeys: null,
                isAddNew: false,
                addressDetails: null
            },
            {
                qId: 3,
                qName: 'Organization Type',
                inputTypeId: 3,
                inputTypeName: 'Dropdown',
                questionGroupId: 2,
                questionGroupName: 'Organization Profile',
                isMandatory: true,
                options: [],
                answerNumeric: 3,
                isAddNew: false,
                addressDetails: null
            },
            {
                qId: 4,
                qName: 'Industry',
                inputTypeId: 1,
                inputTypeName: 'TextField',
                questionGroupId: 2,
                questionGroupName: 'Organization Profile',
                isMandatory: true,
                options: [],
                answerNumeric: null,
                answerText: '',
                answerKeys: null,
                isAddNew: false,
                addressDetails: null
            },
            {
                qId: 19,
                qName: 'Date Format',
                inputTypeId: 3,
                inputTypeName: 'Dropdown',
                questionGroupId: 2,
                questionGroupName: 'Organization Profile',
                isMandatory: true,
                options: [],
                answerNumeric: null,
                isAddNew: false,
                addressDetails: null
            },
            {
                qId: 20,
                qName: 'Currency Code',
                inputTypeId: 3,
                inputTypeName: 'Dropdown',
                questionGroupId: 4,
                questionGroupName: 'Organization Profile',
                isMandatory: true,
                options: [],
                answerNumeric: null,
                isAddNew: false,
                addressDetails: null
            },
            {
                qId: 21,
                qName: 'Heat Map',
                inputTypeId: 3,
                inputTypeName: 'Dropdown',
                questionGroupId: 4,
                questionGroupName: 'Organization Profile',
                isMandatory: true,
                options: [],
                answerNumeric: null,
                isAddNew: false,
                addressDetails: null
            },
            {
                qId: 5,
                qName: 'Head/Corporate Office',
                inputTypeId: 6,
                inputTypeName: 'Tab',
                questionGroupId: 3,
                questionGroupName: 'Address',
                isMandatory: true,
                options: [],
                answerNumeric: null,
                answerText: null,
                answerKeys: null,
                isAddNew: false,
                addressDetails: [
                    {
                        HeadOffice: [
                            {
                                qId: 6,
                                qName: 'Apartment/House/Street',
                                inputTypeId: 1,
                                inputTypeName: 'TextField',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 7,
                                qName: 'Country',
                                inputTypeId: 16,
                                inputTypeName: 'Country',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 8,
                                qName: 'State',
                                inputTypeId: 17,
                                inputTypeName: 'State',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 9,
                                qName: 'City',
                                inputTypeId: 18,
                                inputTypeName: 'City',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 10,
                                qName: 'Pin Code',
                                inputTypeId: 2,
                                inputTypeName: 'Numeric',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: null,
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 11,
                                qName: 'Registered address',
                                inputTypeId: 5,
                                inputTypeName: 'Checkbox',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [
                                    {
                                        id: 7,
                                        value: 'Registered address',
                                        key: 0,
                                        questionId: 0,
                                        questionNavigation: null
                                    }
                                ],
                                answerNumeric: null,
                                answerText: null,
                                answerKeys: [
                                    0
                                ],
                                isAddNew: false,
                                addressDetails: null
                            }
                        ]
                    }
                ]
            },
            {
                qId: 12,
                qName: 'Branch Office(s)',
                inputTypeId: 6,
                inputTypeName: 'Tab',
                questionGroupId: 3,
                questionGroupName: 'Address',
                isMandatory: false,
                options: [],
                answerNumeric: null,
                answerText: null,
                answerKeys: null,
                isAddNew: true,
                addressDetails: [
                    {
                        BranchOffice1: [
                            {
                                qId: 13,
                                qName: 'Apartment/House/Street',
                                inputTypeId: 1,
                                inputTypeName: 'TextField',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 14,
                                qName: 'Country',
                                inputTypeId: 16,
                                inputTypeName: 'Country',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 15,
                                qName: 'State',
                                inputTypeId: 17,
                                inputTypeName: 'State',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 16,
                                qName: 'City',
                                inputTypeId: 18,
                                inputTypeName: 'City',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: '',
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 17,
                                qName: 'Pin Code',
                                inputTypeId: 2,
                                inputTypeName: 'Numeric',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [],
                                answerNumeric: null,
                                answerText: null,
                                answerKeys: null,
                                isAddNew: false,
                                addressDetails: null
                            },
                            {
                                qId: 18,
                                qName: 'Registered address',
                                inputTypeId: 5,
                                inputTypeName: 'Checkbox',
                                questionGroupId: 3,
                                questionGroupName: 'Address',
                                isMandatory: true,
                                options: [
                                    {
                                        id: 8,
                                        value: 'Registered address',
                                        key: 0,
                                        questionId: 0,
                                        questionNavigation: null
                                    }
                                ],
                                answerNumeric: null,
                                answerText: null,
                                answerKeys: [],
                                isAddNew: false,
                                addressDetails: null
                            }
                        ]
                    }
                ]
            }
        ]
    }
]
export const DOT = 'dot'
